import { FILE_SIZE_MULTIPLIER, FILE_SIZE_UNITS } from "@/src/shared_modules/attachments/constants/attachments";

export const formatFileSize = (sizeBytes: string) => {
  let l = 0;
  let n = parseInt(sizeBytes, 10) || 0;
  while (n >= FILE_SIZE_MULTIPLIER && ++l) {
    n = n / FILE_SIZE_MULTIPLIER;
  }
  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + FILE_SIZE_UNITS[l];
};

export const convertMaxSizeToMegaBytes = (sizeB: number) => {
  return Math.round(sizeB / (FILE_SIZE_MULTIPLIER * FILE_SIZE_MULTIPLIER));
};
